import pushModel from "../../mixin/store/api/pushModel";
import axios from "../../plugins/axios";

export default {
    actions: {
        fetchCompanyRemaining(context) {
            return new Promise(((resolve, reject) => {
                axios
                    .get('/companies/' + context.getters.getUserCompanyId + '/remaining')
                    .then(response => {
                        context.commit('updateCompanyRemaining', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyStatistics(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_all_sale_statistics', data)
                    .then(response => {
                        context.commit('updateCompanyStatistics', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyPastStatistics(context) {
            return new Promise(((resolve, reject) => {
                axios
                    .get('/companies/find_past_sale_statistics')
                    .then(response => {
                        context.commit('updateCompanyPastStatistics', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyPayTypeStatistics(context, data) {
            if (context.state.companyPayTypeStatistics.isNeedFetch) {
                return new Promise(((resolve, reject) => {
                    axios
                        .post('/companies/find_pay_type_statistics', data)
                        .then(response => {
                            context.commit('updateCompanyPayTypeStatistics', response.data)
                            resolve()
                        })
                        .catch(() => {
                            reject()
                        })
                }))
            }
        },
        fetchCompanyEmployeeSales(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_employee_sales', data)
                    .then(response => {
                        context.commit('updateCompanyEmployeeSale', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyEmployeesSales(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_employees_sales', data)
                    .then(response => {
                        context.commit('updateCompanyEmployeesSale', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyEmployeePayTypeSales(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_employee_pay_type_sales', data)
                    .then(response => {
                        context.commit('updateCompanyEmployeePayTypeSale', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchOneEmployeeStat(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_employee_statistics', data)
                    .then(response => {
                        context.commit('updateEmployeeStat', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompanyDebtStat(context, data) {
            return new Promise(((resolve, reject) => {
                axios
                    .post('/companies/find_company_statistics', data)
                    .then(response => {
                        context.commit('updateCompanyDebtStat', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        fetchCompany(context) {
            return new Promise(((resolve, reject) => {
                axios
                    .get('/companies/' + context.getters.getUserCompanyId)
                    .then(response => {
                        context.commit('updateCompany', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        updateCompanyRequisites(context, data) {
            return new Promise(((resolve, reject) => {
                axios.interceptors.request.use((config) => {
                    config.headers['Content-Type'] = 'application/ld+json'

                    return config
                })

                axios
                    .put('/companies/' + context.getters.getUserCompanyId, data)
                    .then(response => {
                        context.commit('updateCompany', response.data)
                        resolve()
                    })
                    .catch(() => {
                        reject()
                    })
            }))
        },
        pushCompany(context, data) {
            data.lang = window.i18n.locale
            return pushModel(context, 'companies/make', data)
        },
    },
    mutations: {
        updateCompany(state, data) {
            state.company = data
        },
        updateCompanyRemaining(state, data) {
            state.companyRemaining = data
        },
        updateCompanyStatistics(state, data) {
            state.companyStatistics = data
        },
        updateCompanyPastStatistics(state, data) {
            state.companyPastStatistics = data
        },
        updateCompanyPayTypeStatistics(state, data) {
            state.companyPayTypeStatistics = data
            state.companyPayTypeStatistics.isNeedFetch = false
        },
        updateCompanyEmployeesSale(state, data) {
            state.companyEmployeesSale = data
        },
        updateCompanyEmployeeSale(state, data) {
            state.companyEmployeeSale = data
        },
        updateEmployeeStat(state, data) {
            state.employeeStat = data
        },
        updateCompanyEmployeePayTypeSale(state, data) {
            state.employeePayType = data
        },
        updateCompanyDebtStat(state, data) {
            state.companyDebt = data
        },
    },
    state: {
        company: {
            id: null,
            name: null,
        },
        companyRemaining: {
            "productsPrice": 0,
            "hasMoney": 0,
            "ourDebt": 0,
            "oweUs": 0
        },
        companyStatistics: {
            'totalSaleCurrentDay': 0,
            'totalSaleCurrentMonth': 0,
            'totalSaleCurrentYear': 0,
            'cash': 0,
            'debt': 0,
            'income': 0,
            'bankCard': 0,
            'moneyTransfer': 0
        },
        companyPastStatistics: {
            "lastDayTotalSale": 0,
            "lastMonthTotalSale": 0,
            "lastYearTotalSale": 0,
            "lastDayCash": 0,
            "lastMonthCash": 0,
            "lastYearCash": 0,
            "lastDayDebt": 0,
            "lastMonthDebt": 0,
            "lastYearDebt": 0,
            "lastDayIncome": 0,
            "lastMonthIncome": 0,
            "lastYearIncome": 0,
            "lastDayBankCard": 0,
            "lastMonthBankCard": 0,
            "lastYearBankCard": 0,
            "lastDayMoneyTransfer": 0,
            "lastMonthMoneyTransfer": 0,
            "lastYearMoneyTransfer": 0,
        },
        companyPayTypeStatistics: {
            "bankCard": 0,
            "cash": 0,
            "debt": 0,
            "moneyTransfer": 0,
            "income": 0,
            "cashPercent": 0,
            "debtPercent": 0,
            "bankCardPercent": 0,
            "moneyTransferPercent": 0,
            "totalSale": 0,
            isNeedFetch: true
        },
        companyEmployeeSale: {
            totalSaleSelectedDate: 0,
            totalSalePreviousDate: 0,
            cashSelectedDate: 0,
            cashPreviousDate: 0,
            bankCardSelectedDate: 0,
            bankCardPreviousDate: 0,
            moneyTransferSelectedDate: 0,
            moneyTransferPreviousDate: 0,
            debtSelectedDate: 0,
            debtPreviousDate: 0,
            incomeSelectedDate: 0,
            incomePreviousDate: 0
        },
        employeePayType: {
            cashPercent: 0,
            debtPercent: 0,
            bankCardPercent: 0,
            moneyTransferPercent: 0,
        },
        companyEmployeesSale: [],
        employeeStat: [],
        companyDebt: []
    },
    getters: {
        getCompany(state) {
            return state.company
        },
        getCompanyRemaining(state) {
            return state.companyRemaining
        },
        getCompanyStatistics(state) {
            return state.companyStatistics
        },
        getCompanyPastStatistics(state) {
            return state.companyPastStatistics
        },
        getCompanyPayTypeStatistics(state) {
            return state.companyPayTypeStatistics
        },
        getCompanyEmployeeSale(state) {
            return state.companyEmployeeSale
        },
        getCompanyEmployeesSale(state) {
            return state.companyEmployeesSale
        },
        getCompanyEmployeePayType(state) {
            return state.employeePayType
        },
        getOneEmployeeStat(state) {
            return state.employeeStat
        },
        getCompanyDebtStat(state) {
            return state.companyDebt
        },
    },
}
